<template>
  <div v-if="homeProducts">
    <v-carousel class="mb-2" v-if="$vuetify.breakpoint.mdAndUp"
      hide-delimiter-background
      delimiter-icon="mdi-minus"
      :continuous="true"
      :cycle="true"
      :show-arrows="false"
      :height="$vuetify.breakpoint.lgAndUp ? 350 : 290">
      <v-carousel-item v-for="(image, i) in getBannerImages()" :key="i" :src="image">
      </v-carousel-item>
    </v-carousel>
    <div class="pt-1 px-1" v-else>
      <v-card class="mx-auto">
        <v-carousel v-if="$vuetify.breakpoint.smOnly"
          hide-delimiter-background
          delimiter-icon="mdi-minus"
          :continuous="true"
          :cycle="true"
          :show-arrows="false"
          height="170">
          <v-carousel-item v-for="(image, i) in getBannerImages()" :key="i" :src="image">
          </v-carousel-item>
        </v-carousel>
        <v-carousel v-else
          hide-delimiter-background
          delimiter-icon="mdi-minus"
          :continuous="true"
          :cycle="true"
          :show-arrows="false"
          height="170">
            <v-carousel-item v-for="(image, i) in getBannerMobileImages()" :key="i" :src="image">
            </v-carousel-item>
        </v-carousel>
      </v-card>
    </div>

    <v-row justify="center" class="pt-4 pl-sm-4 pr-sm-4" no-gutters>
      <v-col xl="9" lg="11" md="10" sm="12" cols="10">
        <v-row no-gutters v-if="$vuetify.breakpoint.smAndUp">
          <v-col class="pr-xl-4 pr-lg-4 pr-md-4 pr-sm-2" cols="3">
            <v-card outlined>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon class="blue white--text">account_balance</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="payment-text">Transferencia bancaria</v-list-item-title>
                  <v-list-item-subtitle class="payment-text">Paga desde tu banco</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col class="px-xl-2 px-lg-2 px-md-2 px-sm-1" cols="3">
            <v-card outlined>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon class="blue white--text">money</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="payment-text">Efectivo</v-list-item-title>
                  <v-list-item-subtitle class="payment-text">Paga en efectivo</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col class="pl-xl-4 pl-lg-4 pl-md-4 pl-sm-2" cols="3">
            <v-card outlined>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon class="blue white--text">credit_card</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="payment-text">Tarjeta de credito</v-list-item-title>
                  <v-list-item-subtitle class="payment-text">Hasta 48 cuotas</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col class="pl-xl-4 pl-lg-4 pl-md-4 pl-sm-2" cols="3">
            <v-card outlined>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon class="blue white--text">local_shipping</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="payment-text">Envíos nacionales</v-list-item-title>
                  <v-list-item-subtitle class="payment-text">Rápidos y seguros</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters v-else>
          <v-col class="pr-2" cols="3">
            <v-btn class="mx-2 grey--text" fab>
              <v-icon dark>account_balance</v-icon>
            </v-btn>
            <div class="payment-text-icon text--secondary mt-1">Paga en efectivo</div>
          </v-col>
          <v-col class="px-1" cols="3">
            <v-btn class="mx-2 grey--text" fab>
              <v-icon dark>money</v-icon>
            </v-btn>
            <div class="payment-text-icon text--secondary mt-1">Paga en efectivo</div>
          </v-col>
          <v-col class="pl-2" cols="3">
            <v-btn class="mx-2 grey--text" fab>
              <v-icon dark>credit_card</v-icon>
            </v-btn>
            <div class="payment-text-icon text--secondary mt-1">Hasta 48 cuotas</div>
          </v-col>
          <v-col class="pl-2" cols="3">
            <v-btn class="mx-2 grey--text" fab>
              <v-icon dark>local_shipping</v-icon>
            </v-btn>
            <div class="payment-text-icon text--secondary mt-1">Envíos rápidos y seguros</div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center" class="pt-4 pl-sm-4 pr-sm-4 pb-8" no-gutters v-if="$vuetify.breakpoint.smAndUp">
      <v-col xl="9" lg="11" md="10" sm="12" cols="10">
        <v-row no-gutters v-for="category in getProductsByCategory" :key="'home_category_desk_'+category.category_id">
          <v-col class="text-left pt-2 pr-xl-4 pr-lg-4 pr-md-4 pr-sm-2 mb-n1" cols="12">
            <p class="text--secondary text-lowercase product-title first-capital-letter">{{ category.name }}</p>
          </v-col>

          <v-col class="mb-2" cols="12">
            <v-sheet class="products-slide mx-auto py-1" >
              <v-slide-group center-active class="centered-slide">
                <template v-slot:prev>
                  <v-btn class="ml- blue--text" fab>
                    <v-icon dark>keyboard_arrow_left</v-icon>
                  </v-btn>
                </template>

                <template v-slot:next>
                  <v-btn class="blue--text" fab>
                    <v-icon dark>keyboard_arrow_right</v-icon>
                  </v-btn>
                </template>

                <v-slide-item v-for="product in category.products" :key="'home_product_desk_'+product.product_id">
                  <product-card class="my-1" :product="product"></product-card>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

   <v-row justify="center" class="pt-1 px-4" no-gutters v-else>
      <v-col cols="12">
        <v-row no-gutters v-for="category in getProductsByCategory" :key="'home_category_mobile_'+category.category_id">
          <v-col>
            <v-card class="mx-auto mb-6" elevation="7">
              <div class="text--primary text-left font-weight-medium text-lowercase product-title first-capital-letter pl-2 py-2 mt-2 mx-2">{{ category.name }}</div>
              <v-divider></v-divider>
              <list-image-item-container class="card-border-top" v-for="product in category.products.slice(0, 5)" :key="'home_product_mobile_'+product.product_id">
                <template v-slot:image>
                  <div class="product-image-container" @click="goToProductDetail(product.slug)">
                    <v-img class="product-image" :src="product.image" aspect-ratio="1"></v-img>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="pt-2 mr-3">
                    <div class="text--primary text-left font-weight-light text-lowercase product-title first-capital-letter mt-1">
                      {{product.name}}
                    </div>
                    <div class="headline label-price text-left font-weight-medium mt-1">{{ product.price }}</div>
                    <div class="text-left product-subtitle body-2 grey--text text--darken-1 mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1">{{ product.brand }}</div>
                    <!-- <div class="text-left product-subtitle body-2 mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1 mt-1 free-shipping" v-if="isFreeShipping(index)">Envío gratis</div>
                    <div class="text-left body-2 mt-xl-1 mt-lg-2 mt-md-2 mt-sm-1 mt-1" v-else>Con envíos a nivel nacional</div> -->
                  </div>
                </template>
              </list-image-item-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <home-loader></home-loader>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ProductCard from '@/components/Product/ProductCard'
import ListImageItemContainer from '@/components/List/ListImageItemContainer'
import navigationMixin from '@/mixins/navigation'
import HomeLoader from '@/loaders/HomeLoader'

import { getBannerImages, getBannerMobileImages } from '@/shared/banner'

export default {
  name: 'Home',
  mixins: [navigationMixin],
  components: {
    ProductCard,
    ListImageItemContainer,
    HomeLoader
  },
  computed: {
    ...mapState('product', ['homeProducts']),
    ...mapGetters('product', ['getProductsByCategory'])
  },
  data () {
    return {
      getBannerImages,
      getBannerMobileImages
    }
  },
  methods: {
    ...mapActions('product', ['getHomeProducts']),
    goToProductDetail (slug) {
      this.goToRouteByName('Product-detail', { slug })
    }
  },
  mounted () {
    this.getHomeProducts()
  }
}
</script>
<style scoped>
  .centered-slide >>> .v-slide-group__content{
    display: flex;
    justify-content: center;
  }
  .payment-text{
    font-size:0.75em;
  }
  .payment-text-icon{
    font-size: 0.59375em;
    line-height: 1.33333333333em;
  }
  .products-slide{
    background: transparent;
  }
  .product-title{
    line-height: 1.375em;
  }
  .product-image {
    width: 105px;
    height: 105px;
    border-radius: 0.25rem;
  }
  .product-image-container {
    cursor: pointer;
    position: relative;
    width: 105px;
    height: 105px;
    border-radius: 0.25rem;
  }
  .product-title{
    font-size: 15px;
    line-height: 18px;
  }
  .product-subtitle{
    font-size: 13px !important;
    line-height: 16px;
  }
  .label-price{
    font-size: 22px !important;
  }

  @media only screen and (min-width: 600px) {
    .products-slide{
      max-width: 720px;
    }
  }

  @media only screen and (min-width: 1180px) {
    .products-slide{
      max-width: 960px;
    }
  }

  @media only screen and (min-width: 1264px) {
    .products-slide{
      max-width: 1065px;
    }
  }

  @media only screen and (min-width: 1464px) {
    .products-slide{
      max-width: 1304.25px;
    }
  }

  @media only screen and (min-width: 2100px) {
    .products-slide{
      max-width: 1543.5px;
    }
  }
</style>
